import { Utils } from '@genial/utils';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useBatchTicketInvestLinkActions } from '../../../store/batchTicketInvestLink/action';
import { customerOrderIdState } from '../../../store/batchTicketInvestLink/atom';
import { TfaCodeProps } from '../utils/types';

export const useAuthenticationCustomer = () => {
  const { postTfaCode } = useBatchTicketInvestLinkActions();

  const customerOrderId = useRecoilValue(customerOrderIdState);

  const [loadingToken, setLoadingToken] = useState(false);
  const [errorValidateToken, setErrorValidateToken] = useState(false);
  const [isValidatedToken, setIsValidatedToken] = useState(false);
  const [isExpiredToken, setIsExpiredToken] = useState(false);

  const handleValidateToken = async (value: string) => {
    try {
      setLoadingToken(true);
      setErrorValidateToken(false);
      const tfaToken = await postTfaCode({
        tfaCode: value,
        basketCustomerId: customerOrderId,
      });

      if (tfaToken) {
        validateJwtToken(tfaToken);
      }
    } catch (_error) {
      setErrorValidateToken(true);
    } finally {
      setLoadingToken(false);
    }
  };

  const validateJwtToken = (token: TfaCodeProps) => {
    const decoded = Utils.Jwt.Validate(token.jwtToken);
    const isExpired = decoded && Utils.Jwt.Expired(token.jwtToken);

    if (decoded && !isExpired) {
      setIsValidatedToken(true);
    } else {
      setIsExpiredToken(true);
    }
  };

  return {
    handleValidateToken,
    loadingToken,
    errorValidateToken,
    isValidatedToken,
    isExpiredToken,
  };
};
